import { createFileRoute } from "@tanstack/react-router";
import { FormBuilderPanel } from "@/features/form-editor";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/form/",
)({
	component: FormBuilderPanel,
});
